import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import routes from './routerConfig.js'
import store from '../store'
import cookies from '../libs/util.cookies'
Vue.use(Router)

const router = new Router({
  routes
})


router.afterEach((to, from) => {
  let name = to.name;
  let noBreadCrumb = false
  if (to.meta && to.meta.activePathName) {
    name = to.meta.activePathName
  }
  if (to.meta.noBreadCrumb) {
    noBreadCrumb = to.meta.noBreadCrumb
  }
  store.commit('common/promise/saveNowRoute', name)
  store.commit('common/promise/saveNoBreadCrumb', noBreadCrumb)
})

router.beforeEach((to, from, next) => {
  if (store.state.common.promise.trueRouteNames.length && store.state.common.promise.trueRouteNames.indexOf(to.name) < 0) {
    next({
      name: 'Errorpage'
    })

    return
  }
  if (to.name != 'Login' && !cookies.get('token')) {
    store.commit('common/promise/saveLoginBeforeName', to.name)
    store.commit('common/promise/saveNoBreadCrumb', to.meta.noBreadCrumb)
    next({
      name: 'Login'
    })
  } else {
    store.commit('common/promise/setBreadcrumb', to)
    next()
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js